import './userDataArray.css'
import { useTranslation } from 'react-i18next';
import { useState, useContext } from 'react'
import UserCashLogs from './UserCashLogs/UserCashLogs';
import UserPortfolio from './UserPortfolio/UserPortfolio';
import UserTransactions from './UserTransactions/UserTransactions';
import UserStructuredProducts from './UserStructuredProducts/UserStructuredProducts';
import UserLeveragePositions from './UserLeveragePositions/UserLeveragePositions';
import UserLeverageTransactions from './UserLeverageTransactions/UserLeverageTransactions';
import AuthContext from 'contexte/AuthContext';

const UserDataArray = ({ id }) => {

    const { t } = useTranslation();
    const { verifyUser } = useContext(AuthContext);
    const role = verifyUser()?.role
    const [tab, setTab] = useState(1)

    // Onglets visibles selon le rôle (la compliance, rôle 3, n'a pas accès aux onglets leverage)
    const tabs = [
        { title: 'Transactions', component: <UserTransactions id={id} /> },
        { title: 'Portfolio', component: <UserPortfolio id={id} /> },
        { title: 'Produits Structurés', component: <UserStructuredProducts id={id} /> },
        role !== 3 && { title: 'Leverage Positions', component: <UserLeveragePositions id={id} /> },
        role !== 3 && { title: 'Leverage Transactions', component: <UserLeverageTransactions id={id} /> },
        [1, 2].includes(role) && { title: 'Cash Logs', component: <UserCashLogs id={id} /> },
    ].filter(Boolean)

    return (
        <div>
            <div>
                <div className='transactions_switcher'>
                    {tabs.map(({ title }, index) =>
                        (<div key={index} className={`transactions_tab ${tab === index ? "transactions_tab_select" : "transactions_tab_not_select"}`} onClick={() => { setTab(index) }}>{title}</div>)
                    )}
                </div>
                {
                    tabs[tab]?.component
                }
            </div>

        </div>)
}

export default UserDataArray